import React, { FC, useEffect } from "react";
import { useSelector } from "react-redux";
import { hideLoading } from "redux/commonSlice";
import { useAppDispatch } from "redux/hooks";
import "./Loading.css";

interface LoadingProps {}

const Loading: FC<LoadingProps> = () => {
  const {show, time} = useSelector((state: any) => state.common.loadingState);
  const dispatch = useAppDispatch()
  React.useEffect(()=>{
    if(time> 0){
      console.log(time)
      setTimeout(()=>{
        if(show){
          dispatch(hideLoading());
        }
      },time)
    }
  })
  return (
    <>
    { show ? <div className="loading">
				<div
					className="uil-ring-css"
					style={{ transform: `scale(0.79)` }}
				>
					<div></div>
				</div>
			</div> : ''
      
    }
      </>
  )
};

export default Loading;
